import React, { useState, useEffect } from 'react';
import './ListUpdateMessage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function ListUpdateMessage({ lastUpdate, message  }) {
  const [visible, setVisible] = useState(true);

  if (logComponent('ListUpdateMessage')) { console.debug('ListUpdateMessage rendered'); }

  useEffect(() => {
    if (logComponent('ListUpdateMessage')) { console.debug('ListUpdateMessage useEffect [lastUpdate]'); }
    setVisible(true);
  }, [lastUpdate]);

  const hide = () => {
    if (logComponent('ListUpdateMessage')) { console.debug('ListUpdateMessage hide'); }
    setVisible(false);
  }


  return visible ?
    <div className="List-Update-Message">
      <p className="List-Update-Message__text">{message}</p>
      <button
        className="List-Update-Message__close-button"
        onClick={hide}>
        <FontAwesomeIcon icon="times" />
      </button>
    </div> :
    null;
}